import React, { useState, useEffect } from "react";
import arise from "../assets/imgs/Arise.png";
import lines1 from "../assets/imgs/BG Effects/Lines 1.png";

const Hero = () => {
  const [displayText, setDisplayText] = useState("");
  const text = "ARISE";

  useEffect(() => {
    let index = 0;
    let deleting = false;
    let timeout;

    function type() {
      if (!deleting) {
        setDisplayText(text.slice(0, index + 1));
        index++;
        if (index === text.length) {
          deleting = true;
          timeout = setTimeout(type, 1500);
          return;
        }
      } else {
        setDisplayText(text.slice(0, index - 1));
        index--;
        if (index === 0) {
          deleting = false;
        }
      }
      timeout = setTimeout(type, deleting ? 100 : 600);
    }

    type();

    return () => clearTimeout(timeout); // cleanup
}, []);

  return (
    <section id="home" className="hero">
      <div className="grid-bg ba-grid anim">
        <div className="inner"></div>
      </div>

      <div className="effect-1">
        <img src={lines1} alt="Decorative lines" />
      </div>

      <div className="hero-content">
        <h1 className="typing-text">{displayText}</h1>
        <p>MEDICAL SERVICE INNOVATORS</p>
        <hr />
      </div>

      <div className="hero-image">
        <img src={arise} alt="ARISE illustration" />
      </div>
    </section>
  );
};

export default Hero;
